
<template>
      <div class="record" :class="recordif?'to':''">
        <div class="sale-tanpg"> 
            <h5>
                <a @click="romboxhide(5)" class="title" href="javascript:void(0);"></a>   
                赠送记录
            </h5>
            <nav class="clearfix">
                <a class="get" :class="navindex==0?'chenck':''"  @click="recorddata(0)" href="javascript:void(0);">我收到的卡片</a>
                <a class="to" :class="navindex==1?'chenck':''" @click="recorddata(1)" href="javascript:void(0);">我送出的卡片</a>
            </nav>
            <div class="record-box">
                <h6 v-if="textif">此处信息每小时更新 <a @click="romhide" class="rom" href="javascript:void(0);"></a></h6>
                <ul v-if="data.length>0">
                    <li v-for="(item,index) in data" :key="index">
                        <img class="im1" :src="'//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/car2_'+item.indexka+'.png'" alt="">
                        <img class="ren" :src="item.storeLogo||'//i0.ulecdn.com/i/event/2019/0509/boatRank/avatar_default.png'" alt="">
                        <div class="text">
                            <p class="p1">{{item.storeName}}</p>
                            <p>{{item.userTrueName}}</p>
                        </div>
                        <span class="ap1">{{item.dealTime}}</span>
                    </li>
                </ul>
                <div v-if="data.length<=0" class="nojiru">{{notext}}</div>
            </div>  
                
        </div>
    </div>
</template>

<script>
export default {
  props:['recordif','ifylxd','cardnolist','cardActivityNo'],
  data () {
      return {
          textif:true,
          data:[],
          navindex:'0',
          notext:'您暂未收到卡片',
      }
    },
    created(){
        if(this.ifylxd){
            this.recorddata(0)
        }
    }, 
    methods:{
          romhide(){
              let m=this;
              m.textif=false;
          },
          romboxhide(nu){
              this.$parent.shouxiaokapicha(nu);
          },
          recorddata(flg){
              let m=this;
              m.navindex=flg;
              if(m.navindex==0){
                  m.notext='您暂未收到卡片';
              }else{
                  m.notext='您还未送出过卡片';
              }
              this.HTTP.qryReAndSendCardhttp(flg,m.cardActivityNo).then((res) => { 
                  let obj=res.body;
                if(res.body.returnCode=="0000"&&res.body.data){
                    for(var i=0;i<obj.data.length;i++){
                        obj.data[i].cardPicUrl=obj.data[i].cardPicUrl;
                        obj.data[i].indexka=m.cardnolist[obj.data[i].cardPicUrl].inde;
                    }
                    m.data=obj.data;
                }
             },(ree) =>{
                   
                });
          }
    } 
}
</script>

<style scoped>
.record{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left:100%;
    z-index: 9999; 
    transition: all 1s;
}
.record.to{
    left:0%;
}
.record .sale-tanpg{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    max-width: 640px;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg4.png) no-repeat center;
    background-size: 100% 100%;

}
.record h5{
    display: block;
    height: 0.8rem;
    text-align: center;
    line-height: 0.8rem;
    font-size: .36rem;
    color: #fff;
    position: relative;
    background-color: #F03B3B;
}
.record h5 a{
    position: absolute;
    height: .3rem;
    width: .3rem;
    left: .2rem;
    top: .23rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i4.png) no-repeat left center;
    background-size: .3rem .3rem;
}
nav{
    display: block;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    background-color: #F03B3B;
}
nav a{
    display: block;
    width: 50%;
    text-align: center;
    color: #FAC4C4;
    font-size: .3rem;
    float: left;
    position: relative;
}
nav .to{
    float: right;
}
nav a.chenck{
    color: #fff;
}
nav a.chenck::before{
    content: '';
    line-height: 0;
    height: .04rem;
    width: 30%;
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: .02rem;
}
.record-box{
    display: block;
    width: 100%;
    height: calc(100vh - 1.6rem);
    overflow-y: scroll;
    padding: 0 .2rem;
    box-sizing: border-box;
    padding-top: 0.2rem;
}
.record-box h6{
    display: block;
    line-height: 0.72rem;
    height: 0.72rem;
    border-radius: .36rem;
    background-color: #DA3344;
    color: #FFD183;
    font-size: .26rem;
    padding-left: 0.32rem;
    margin-bottom: 0.2rem;
    position: relative;
}
.rom{
    height: 100%;
    position: absolute;
    width: 7%;
    top: 0;
    right: 0;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i4.png) no-repeat left center;
    background-size: .2rem .2rem;

}
ul{
    display: block;
}
li{
    display: block;
    height: 1.38rem;
    position: relative;
    margin-bottom: 0.18rem;
}
.im1{
    height: 100%;
    display: inline-block;
    width: auto;
    vertical-align: middle;
}
.ren{
    position: absolute;
    width: 0.88rem;
    height: 0.88rem;
    top: 50%;
    transform:translateY(-50%);
    left: 1.1rem;
    border-radius: .44rem;
}
.ap1{
    font-size: .26rem;
    line-height: 1.38rem;
    color: #E8AB92;
    float: right;
    margin-right: 0.2rem;
}
.text{
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 46%;
    left: 2.12rem;
}
.text p{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: .24rem;
    color: #FFE8AB92;
}
.text .p1{
    font-size: .28rem;
    color: #FFFFEDC2;
}
.nojiru{
    display: block;
    width: 100%;
    font-size: .36rem;
    color: #FFD18F;
    text-align: center;
    padding-top: 45%;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/record.vue